import { Search } from 'lucide-react';
import { Button } from '../ui/Button';

type Props = {
  query: string;
  setQuery: (v: string) => void;
  before: number;
  setBefore: (v: number) => void;
  after: number;
  setAfter: (v: number) => void;
  matchCount: number;
  totalLines: number;
};

export function LogSearchBar({ query, setQuery, before, setBefore, after, setAfter, matchCount, totalLines }: Props) {
  const hasQuery = String(query).trim().length > 0;

  return (
    <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-800 flex flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search logs..."
            className="w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>
        <Button size="sm" variant="outline" onClick={() => setQuery('')} disabled={!hasQuery}>
          Clear
        </Button>
      </div>

      <div className="flex flex-wrap items-center gap-3 text-xs text-gray-600 dark:text-gray-400">
        <div className="flex items-center gap-2">
          <span>Before</span>
          <input
            type="number"
            min={0}
            max={200}
            value={before}
            onChange={(e) => setBefore(Number(e.target.value))}
            className="w-16 px-2 py-1 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          />
        </div>
        <div className="flex items-center gap-2">
          <span>After</span>
          <input
            type="number"
            min={0}
            max={200}
            value={after}
            onChange={(e) => setAfter(Number(e.target.value))}
            className="w-16 px-2 py-1 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          />
        </div>

        <div className="ml-auto">
          {hasQuery ? (
            <span>
              Matches: <span className="text-gray-900 dark:text-gray-100">{matchCount}</span> · Showing{' '}
              <span className="text-gray-900 dark:text-gray-100">match + context</span>
            </span>
          ) : (
            <span>
              Lines: <span className="text-gray-900 dark:text-gray-100">{totalLines}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

